export const arrow_down = require('./arrow_down.svg');
export const arrow_up = require('./arrow_up.svg');
export const close = require('./close.svg');
export const facebook = require('./facebook.svg');
export const filter_list = require('./filter_list.svg');
export const handHouse = require('./hand-house.svg');
export const handUser = require('./hand-user.svg');
export const house = require('./house.svg');
export const info = require('./info.svg');
export const instagram = require('./instagram.svg');
export const key = require('./key.svg');
export const linkedin = require('./linkedin.svg');
export const lock = require('./lock.svg');
export const magnifyingGlass = require('./magnifying-glass.svg');
export const place = require('./place.svg');
export const play = require('./play.svg');
export const stackOfCoins = require('./stack-of-coins.svg');
export const stoneWall = require('./stone-wall.svg');
export const thumb_up = require('./thumb_up.svg');
export const twitter = require('./twitter.svg');
export const videocam = require('./videocam.svg');
export const view_module = require('./view_module.svg');